// @flow
export const MODEL = 'OrderTests'
export const TREE = 'ordersData'
export const BRANCH = 'orders'

export const OPERATIONS_TREE = 'ordersModule'
export const OPERATIONS_BRANCH = 'orderTestOperation'

// Api End Point
export const URL = 'hefty/order/'

// Model Properties
export const PROP_ID = 'id'
export const PROP_CLIENT = 'client'
export const PROP_ADDRESS = 'address'
export const PROP_CITY = 'city'
export const PROP_PROVINCE = 'province'
export const PROP_POSTAL_CODE = 'postal_code'
export const PROP_COUNTRY = 'country'
export const PROP_PHONE = 'phone'
export const PROP_MOBILE_PHONE = 'mobile_phone'
export const PROP_EMAIL = 'email'
export const PREFERRED_CONTACT = 'preferred_contact'
export const PROP_ORDERED_DATE = 'ordered_date'
export const PROP_CALCULATED_SALES_TAX = 'calculated_sales_tax'
export const ORDER_TOTAL = 'order_total'
export const SUPPLIES = 'supplies'
